import React from 'react'
import { FormattedMessage } from 'react-intl'

import {
  getShippingEstimateMessage,
  collapsePickupOptions,
} from '@/checkout-instore-legacy/shipping/utils'
import { getIntlMessage } from '@/checkout-instore-legacy/i18n/utils'
import Selector from '@/checkout-instore-legacy/components/Commons/Elements/Selector'
import Price from '@/checkout-instore-legacy/components/Commons/Price'
import { PICKUP_DELIVERY_CHANNEL } from '@/checkout-instore-legacy/shipping/constants'

type ChangeSelectorProps = {
  index: number
  logisticsInfoItem: LogisticsInfoItem
  onSlaSelection: (index: number, value: SLA) => void
}

const ChangeSelector = ({
  index,
  logisticsInfoItem,
  onSlaSelection,
}: ChangeSelectorProps) => {
  const handleSelect = (value: SLA) => {
    onSlaSelection(index, value)
  }

  return (
    <Selector
      renderCustomButton={({
        handleMenuOpen,
      }: {
        handleMenuOpen: () => void
      }) => (
        <button
          id={`change-sla-selector-${index}`}
          className="bn  c-action-primary f5 fw5 pointer tl"
          style={{
            padding: '$space-0',
            margin: '$space-0',
            background: 'transparent',
          }}
          onClick={handleMenuOpen}
        >
          <FormattedMessage id="shippingSlaSelectorChangeButton" />
        </button>
      )}
      data={
        logisticsInfoItem &&
        collapsePickupOptions(logisticsInfoItem.slas).map((sla: SLA) => {
          const selected =
            logisticsInfoItem.selectedSla &&
            (logisticsInfoItem.selectedSla === sla.id ||
              (sla.deliveryChannel === PICKUP_DELIVERY_CHANNEL &&
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'deliveryChannel' does not exist on type ... Remove this comment to see the full error message
                logisticsInfoItem.selectedSla.deliveryChannel ===
                  PICKUP_DELIVERY_CHANNEL))

          return {
            key: `${index}-slaOption-${sla.id}`,
            selected,
            label: (
              <div id={`change-sla-option-${sla.id}`} className="tc">
                <div className="flex dib mv4 f6 f4-ns">
                  <div className="mr-auto ml-auto">
                    {sla.deliveryChannel === PICKUP_DELIVERY_CHANNEL
                      ? getIntlMessage('shippingSlaSelectorPickup')
                      : `${sla.id} `}
                    <span className="fw7">
                      {' '}
                      {/* // TODO: this error popped up when moving the checkout-instore project
                      // to checkout-instore-legacy, but needs to be fixed at some point
                      // @ts-ignore */}
                      <Price value={sla.price} />
                      {' - '}
                      {getShippingEstimateMessage(sla.shippingEstimate)}
                    </span>
                  </div>
                </div>
              </div>
            ),
            value: sla,
          }
        })
      }
      placeholder={getIntlMessage('shippingAddressChangeDeliveryLabel')}
      onSelect={handleSelect}
    />
  )
}

export { ChangeSelector }
